export const FETCH_LIST_ALL_DOCUMENTS_FOR_PROJECT_ASSOCIATION_REQUEST = 'FETCH_LIST_ALL_DOCUMENTS_FOR_PROJECT_ASSOCIATION_REQUEST'
export const FETCH_LIST_ALL_DOCUMENTS_FOR_PROJECT_ASSOCIATION_SUCCESS = 'FETCH_LIST_ALL_DOCUMENTS_FOR_PROJECT_ASSOCIATION_SUCCESS'
export const FETCH_LIST_ALL_DOCUMENTS_FOR_PROJECT_ASSOCIATION_FALUIRE = 'FETCH_LIST_ALL_DOCUMENTS_FOR_PROJECT_ASSOCIATION_FALUIRE'
